// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"bb4f1575","54":"6fdf84ea","100":"bc8ffac8","143":"6b46ba89","241":"48b0efe0","336":"6de80a8d","370":"8fd9b51f","943":"13075d63"}[chunkId] + ".chunk.js";
};